// Country display helpers, shared by the Observatory board and the hero
// teaser. "XX" (unattributable) is special-cased by callers via copy — these
// helpers just do the mechanical part.

/** "KR" → 🇰🇷 (two regional-indicator code points). */
export function countryFlag(code: string): string {
  return String.fromCodePoint(...[...code].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65));
}

const regionNames = (() => {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" });
  } catch {
    return null; // ancient browser — the code alone still reads fine
  }
})();

export function countryName(code: string): string {
  try {
    return regionNames?.of(code) ?? code;
  } catch {
    return code;
  }
}
